import { gql } from '@guuru/graphql-common/gql';

const communityExpertFragment = gql(`#graphql
  fragment CommunityExpertFragment on CommunityExpert {
    id
    externalId
    bio
    photoUrl
    name
    joinedAt
    rating
    moments {
      id
      url
    }
  }
`);

export default communityExpertFragment;
